import List from '@utils/list'
import getData from './config/getData'
import MultipleTable from '@utils/multiple-table'
import detail from './config/detail'
import Select from '@utils/common/select'
import Jurisdiction from '@utils/jurisdiction'
import { tableExport } from '@utils/index'
const { Search, Table } = List

function exportTable(this: any, data: any) {
  console.log(data.selection)
  const workorderNos = data.selection.map((res: any) => res.workorderNo)
  const siteList = data.selection.map((res: any) => res.site)
  const supplierNos = data.selection.map((res: any) => res.supplierNo)
  tableExport({
    name: this.$t('orderpurchase.ordertrack.fildName'),
    url: '/srmPurWorkorder/exportWorkorderInfo',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: {
      condition: { workorderNos,
        siteList,
        supplierNos }
    }
  })
}

const jurisdiction = new Jurisdiction('newTrace.Particulars')
  .lib('export').handle(exportTable)

const search = new Search('orderpurchase.outorderissue')
  .placeholder('searchPlaceholder')
  .lib('dateRange').mapKey('purchaseDateRange').label('purchaseDateRange').prop(['purchaseDateStart', 'purchaseDateEnd'])
  .add('productGoodsNo')
  // .lib('dateRange').mapKey('expectArrivalDateRange').label('expectArrivalDateRange').prop(['expectArrivalDateStart', 'expectArrivalDateEnd'])
  .add('productGoodsName')
  .add('productSpec')
  .add('purchaseUnitNo').label('purOfficeName').select(Select.use('/purchaseUnit/getPurchaseUnitPage').params({ usingFlag: '1' }))

search.mixins = {
  created(this: any) {
    if (this.$route.query.purchaseNo) {
      this.keyword = this.$route.query.purchaseNo
    }
  }
}

const childTable = new Table('orderpurchase.outorderissue')
  .type('index')
  .sortable(false)
  .add('goodsNo')
  .add('goodsName')
  .add('spec')
  .add('unitNo').format(data => `${data.row.unitNo}-${data.row.unitName}`)
  .add('collectQty')
  .label('needsAmount')
  .add('collectedQty')
  .label('usedAmount')
  .add('unCollectQty')
  .label('unreceivedAmount')

const table = new MultipleTable('orderpurchase.outorderissue')
  .type('selection')
  .table(childTable)
  .sortable(false)
  .listProp('list')
  .add('purchaseNo')
  .sort('custom')
  .add('docDate')
  .sort('custom')
  .label('purchaseDate')
  .add('workorderNo')
  .sort('custom')
  .label('docNo')
  .link()
  // .add('purOfficeName')
  .add('supplierName')
  .add('productGoodsNo')
  .label('finishedGoodsNo')
  .add('productGoodsName')
  .label('finishedGoodsName')
  .add('productSpec')
  .label('finishedSpec')
  .add('productUnitNo').format(data => `${data.row.productUnitNo}-${data.row.productUnitName}`)
  .add('outputQty')
  .label('expectedAmount')
  .add('collectedSetsQty')
  .label('numCollars')
  .add('purchaseUnitName')
  .label('purOfficeName')
  .html((row: any) => `${row.row.purchaseUnitName}`)
  // .format((row: any) => console.log(row))

export default new List()
  .name('Ordersupplier.Outorderissue')
  .api(getData)
  .sort({ field: 'docDate', order: 'desc' })
  .search(search)
  .table(table)
  .jurisdiction(jurisdiction)
  .detail(detail)
  .end()
